import { UnifiedAttachmentRef, UnifiedSendEmailRequest } from './unifiedEmail';

export interface ScheduledEmailAttachmentRef extends UnifiedAttachmentRef {
  size?: number;
}

export enum ScheduledEmailStatus {
  PENDING = 'pending',
  SENDING = 'sending',
  SENT = 'sent',
  FAILED = 'failed',
  CANCELED = 'canceled',
}

export const SCHEDULED_EMAIL_TERMINAL_STATUSES: readonly ScheduledEmailStatus[] =
  [ScheduledEmailStatus.SENT, ScheduledEmailStatus.FAILED];

/**
 * Links a scheduled send back to the executor ledger row that approved it,
 * so a later cancel/undo can find and supersede that row. Readable ids and
 * a timestamp only — never folded into `request`, which stays the email
 * content contract alone.
 */
export interface ScheduledEmailExecutorLedgerRef {
  conversationId: string;
  runId: string;
  msgIdx: string;
  taskGroupId: string;
  inboxEntryId: string;
  // Epoch ms the approval that scheduled this send was granted.
  approvedAt: number;
  // convMsgIdx of the message this schedule anchors a later undo/rebind to, when known.
  anchorMessageId?: string;
  // Key of the sealed DRAFT# the approved body was proposed as (an HMAC digest, no content): lets the send record how much the owner edited it.
  draftRef?: string;
}

export interface ScheduledEmail {
  userId: string;
  scheduledEmailId: string;
  status: ScheduledEmailStatus;
  scheduledFor: number; // epoch seconds, UTC
  request: UnifiedSendEmailRequest;
  createdAt: number;
  updatedAt: number;
  lastError?: string;
  sentMessageId?: string;
  executorLedgerRef?: ScheduledEmailExecutorLedgerRef;
}

export interface CreateScheduledEmailInput {
  scheduledFor: number; // epoch seconds, UTC
  request: UnifiedSendEmailRequest;
}

export interface UpdateScheduledEmailRequestInput {
  subject?: string;
  body?: string;
  additionalText?: string;
  toAddresses?: string[];
  ccAddresses?: string[];
  bccAddresses?: string[];
  attachments?: UnifiedAttachmentRef[];
}

export interface UpdateScheduledEmailInput {
  scheduledEmailId: string;
  scheduledFor?: number; // epoch seconds, UTC
  request?: UpdateScheduledEmailRequestInput;
}
